import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveUserIntraSquadMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveIntraSquadMatch, useRetrieveTeam, useUpdateIntraSquadMatch, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { IntraSquadMatchForm } from "./IntraSquadMatchForm";
export var UpdateIntraSquadMatch = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveUserIntraSquadMatchPermissions({ intraSquadMatchId: id }), userIntraSquadMatchPermissions = _a.data, userIntraSquadMatchPermissionsIsLoading = _a.isLoading, userIntraSquadMatchPermissionsError = _a.error;
    var _b = (userIntraSquadMatchPermissions || {}).canModify, canModify = _b === void 0 ? false : _b;
    var _c = useRetrieveIntraSquadMatch({ id: id, enabled: canModify }), useRetrieveIntraSquadMatchIsLoading = _c.isLoading, useRetrieveIntraSquadMatchError = _c.error, intraSquadMatch = _c.data;
    var _d = useRetrieveTeam({ id: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), team = _d.data, teamError = _d.error, teamIsLoading = _d.isLoading;
    var navigate = useNavigate();
    var mutation = useUpdateIntraSquadMatch({
        id: id,
        team: team,
        onMutate: function () { },
        onSuccess: function () {
            return navigate("/intra-squad-matches/".concat(id, "/"));
        },
        onError: console.error,
    });
    var onSubmit = function (intraSquadMatch) {
        mutation.mutate(intraSquadMatch);
    };
    if (useRetrieveIntraSquadMatchIsLoading || teamIsLoading) {
        return _jsx(Loading, {});
    }
    if (userIntraSquadMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userIntraSquadMatchPermissionsError) {
        return _jsx(ErrorView, { error: userIntraSquadMatchPermissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (useRetrieveIntraSquadMatchError ||
        !(intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team) ||
        !team ||
        teamError) {
        return _jsx(ErrorView, { error: useRetrieveIntraSquadMatchError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update Intra-Squad Match. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Update Intra-Squad Match for ", team.name] }) }), _jsx(IntraSquadMatchForm, { intraSquadMatch: intraSquadMatch, team: team, onSubmit: onSubmit })] }));
};
